import Container from "../global/container";
import Images from "../global/images";
import useFeatureFlag from "@/hooks/useFeatureFlag";

const Companies = () => {
  const isCompaniesVisible = useFeatureFlag("companiesSection");

  if (!isCompaniesVisible) return null;

  return (
    <div
      className="relative flex flex-col items-center justify-center w-full py-20 mt-16 companies overflow-hidden"
      data-oid="tmy7tf8"
    >
      <Container data-oid=".l-l4ih">
        <div
          className="flex flex-col items-center justify-center"
          data-oid=":sopsg3"
        >
          <h4 className="text-2xl lg:text-4xl font-medium" data-oid="1n3heyi">
            Trusted by{" "}
            <span className="font-subheading italic" data-oid="7fsv89t">
              leading
            </span>{" "}
            brands
          </h4>
        </div>
      </Container>
      <Container delay={0.1} data-oid="rly9vwx">
        <div
          className="flex flex-row flex-wrap items-center justify-center gap-8 max-w-xl mx-auto pt-16 text-muted-foreground transition-all"
          data-oid="xndwi1c"
        >
          <Images.company1
            className="h-7 w-auto hover:text-foreground"
            data-oid="29iue0h"
          />
          <Images.company2
            className="h-7 w-auto hover:text-foreground"
            data-oid="9zy0w4x"
          />
          <Images.company3
            className="h-7 w-auto hover:text-foreground"
            data-oid="bfki9ey"
          />
          <Images.company6
            className="h-7 w-auto hover:text-foreground"
            data-oid="e0s2omp"
          />
          <Images.company7
            className="h-7 w-auto hover:text-foreground"
            data-oid="_v0mu1d"
          />
          <Images.company9
            className="h-7 w-auto hover:text-foreground"
            data-oid="otxntxx"
          />
          <Images.company10
            className="h-7 w-auto hover:text-foreground"
            data-oid="hy6xb25"
          />
        </div>
      </Container>
    </div>
  );
};

export default Companies;
